import $ from 'jquery';

export const show = function ($call) {
    const content = $call.data('ui-tooltip-content');

    const topPosition = $call.data('ui-tooltip-topposition');
    const leftPosition = $call.data('ui-tooltip-leftposition');
    const color = $call.data('ui-tooltip-color');
    const widthToken = $('.js-TooltipBox-Token').width();
    const widthMax = $call.data('ui-tooltip-maxwidth');

    const tooltipToken = {
        render: () => (
            `<small class="js-TooltipBox-Token ui-TooltipBox-Token">${content}</small>`
        ),
    };

    const tooltip = {
        render: () => (
            `<span class="js-TooltipBox-Box ui-TooltipBox-Box">${content}</span>`
        ),
    };

    $call.parents('body').append(tooltipToken.render());
    $call.css('position', 'relative');
    $call.append(tooltip.render());

    const tooltipBox = $call.find('.js-TooltipBox-Box');
    const width = (widthMax && (widthToken < widthMax)) ? `${widthToken + 21}px` : 'auto';

    tooltipBox.css({
        width,
        backgroundColor: color || '#1f1f7b',
        left: leftPosition || '-10px',
        'max-width': widthMax || '',
    });

    const height = tooltipBox.height();
    const top = typeof topPosition !== 'undefined' ? `${topPosition}px` : `-${(+height + +20)}px`;

    tooltipBox
        .css({ top })
        .addClass('fn-visible');
};

export const hide = function ($call) {
    $call.find('.js-TooltipBox-Box').remove();
    $('.js-TooltipBox-Token').remove();
};

export default {
    init(params) {
        const elements = {
            call: '.js-tooltipBox-Call',
        };

        params
            .$document
            .on('mouseenter', elements.call, function () {
                show($(this));
            })
            .on('mouseleave', elements.call, function () {
                hide($(this));
            });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/tooltip-box.js